import React, { useState } from 'react'
import { Button } from '../../components/ui/Button'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react'
import { LeftArrowWhite } from 'src/assets/images/svg/LeftArrow'
import { applicationStore } from 'src/store/ApplicationStore'
import PhoneNumberInput from 'src/components/ui/PhoneNumberInput'
import Preloader from 'src/components/ui/Preloader'
import { workflowStepIterator } from 'src/services/workflowStepIterator'
import { NodeTypes } from 'src/enums/NodeTypes'
import { parseServiceErrorMessage } from 'src/helpers/parseServiceError'
import { useTranslation } from 'react-i18next'

const PhoneVerification = observer(() => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isActive, setIsActive] = useState(false);
    const [phoneValue, setPhoneValue] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSendSms = async () => {
        try {
            setSubmitting(true);
            const response = await workflowStepIterator({
                access_token: applicationStore.access_token,
                node_id: applicationStore.workflowNextServiceResponse.node_id,
                body: {
                    "phone": phoneValue
                },
                action_index: 0,
                constextOfStep: { step: NodeTypes.PHONE_VERIFICATION, "retry": applicationStore.workflowNextServiceResponse.retry }
            })
            if (response.data?.service_results[0].status !== 200) {
                const rawMessage = response.data?.service_results[0]?.message;
                const parsedMessage = parseServiceErrorMessage(rawMessage);
                throw new Error(parsedMessage);
            }
            applicationStore.setWorkflowNextServiceResponse(response.data);
            toast.success(t('checkYourDevice.smsSent'));
            navigate("/confirm-phone", { replace: true, state: { phoneValue } });

        } catch (error) {
            toast.error(error?.message || t('checkYourDevice.smsNotSent'));
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="custom-container">
            <div className="flex w-full flex-col text-left h-full">
                <div className="w-full">
                    <div className='text-left'>
                        <Button className="" variant="primaryBack" onClick={() => { navigate(`/?aid=${applicationStore.aidCode}`, { replace: true }) }}><LeftArrowWhite /></Button>
                    </div>
                    <div className='grid gap-[16px] mt-10 w-full text-left'>
                        <div className="text-h5 font-bold text-flow-heading">{t('phoneVerification.title')}</div>
                        <div className="text-body text-Gray900">{t('phoneVerification.description')}</div>
                    </div>
                    <div className='mt-10'>
                        <PhoneNumberInput setIsActive={setIsActive} setPhoneValue={setPhoneValue} countryCode={applicationStore.country.toUpperCase()} />
                    </div>
                    <div className='mt-6 w-full'>
                        <Button className="mt-4" variant="primaryWithoutIcon" disabled={!isActive || submitting} onClick={handleSendSms}>
                            <span className="me-1">{t('actions.continue')}</span>{submitting && <Preloader variant='white' />}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default PhoneVerification
